module.exports = __webpack_public_path__ + "img/david-siglin-87978.ab5f1b08.jpg";